import { render } from "./ZoneCreateModal.vue?vue&type=template&id=223eba54&ts=true"
import script from "./ZoneCreateModal.vue?vue&type=script&lang=ts"
export * from "./ZoneCreateModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__